import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'


import VuePrism from 'vue-prism'
Vue.use(VuePrism)

import 'photoswipe/dist/photoswipe.css';


import 'prismjs/themes/prism.css'

import VueCodemirror from 'vue-codemirror'

// Vue.prototype.isDev = !window.location.href.startsWith('https://')
Vue.prototype.isDev = window.location.href.startsWith('http://codeserver') ||
                      window.location.href.includes('http://crashcode') ||
                      window.location.href.includes('http://core1')


import VueMarkdown from 'vue-markdown'

Vue.use(VueMarkdown)
Vue.component('vue-markdown', VueMarkdown)

// require styles
import 'codemirror/lib/codemirror.css'
Vue.use(VueCodemirror)

import M from 'materialize-css'

Vue.prototype.$apiprefix = 'http://automation:9000'
Vue.prototype.$apiprefix = `/api` // crashcode:8008/ for blog
if (window.location.href.includes('codeserver'))
  Vue.prototype.$apiprefix = 'http://automation:9000'
Vue.prototype.$col = 'crashcode3'
Vue.prototype.$imgcol = 'gallery'


Vue.prototype.M = M

Vue.prototype.send_toast = (msg, status) => {
  if (status == 'ok'){
    M.toast({
      html: msg,
      classes: 'green darken-1 rounded'
    })
  }else if (status == 'err'){
    M.toast({
      html: msg,
      classes: 'red darken-1 rounded'
    })
  }else{
    M.toast({
      html: msg,
    })
  }
}

const copyToClipboard = (str, b64=false) => {
  if (b64) str = atob(str)
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const copyToClipboardRich = (str, b64=false) => {
  if(b64) str = atob(str)
  function listener(e){
    e.clipboardData.setData("text/html ", str)
    e.clipboardData.setData("text/plain ", str)
    e.preventDefault()
  }
  document.addEventListener('copy', listener)
  document.execCommand('copy')
  document.removeEventListener('copy', listener)
};

//https://stackoverflow.com/questions/19721439/download-json-object-as-a-file-from-browser
const forceJSONDownload = (data, filename='data.json') => {
  let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data));
  let dlAnchorElem = document.createElement('a');
  dlAnchorElem.setAttribute("href",     dataStr     );
  dlAnchorElem.setAttribute("download", filename);
  dlAnchorElem.click();
}

Vue.prototype.forceJSONDownload = forceJSONDownload
Vue.prototype.copyToClipboard = copyToClipboard
Vue.prototype.copyToClipboardRich = copyToClipboardRich


Vue.use(VueAxios, axios)


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
